import IconDownload from 'approot/shared/icons/icon-download';
import { Dropdown } from 'approot/shared/dropdown/dropdown';
import { DropdownItem } from 'approot/shared/dropdown/dropdown-item.style';
import { SettingsDrawerButton } from 'approot/activity-builder/settings/settings-drawer.style';
import { PRESENT_MENU_CONTAINER_ID } from '../activity-builder-present.constants';

const PresentMenuDownloadOptions = ({
  onClickDownloadActivities,
  onClickDownloadResponses,
}: {
  onClickDownloadActivities: () => void;
  onClickDownloadResponses: () => void;
}) => {
  return (
    <Dropdown
      data-selector="present-menu-download"
      menuWidth={250}
      aria-label="More options for downloading activities"
      menuContainerElement={PRESENT_MENU_CONTAINER_ID}
      borderRadius={4}
      dropdownContents={
        <>
          <DropdownItem
            onClick={onClickDownloadActivities}
            data-selector="option-activities-pdf"
          >
            Activities PDF
          </DropdownItem>
          <DropdownItem
            onClick={onClickDownloadResponses}
            data-selector="option-students-responses"
          >
            Students Responses
          </DropdownItem>
        </>
      }
      dropdownButtonContents={
        <SettingsDrawerButton
          data-selector="present-menu-download"
          type="button"
          aria-haspopup="dialog"
          $isActive={false}
        >
          <IconDownload width={24} height={24} />
          <span>Download</span>
        </SettingsDrawerButton>
      }
    />
  );
};

export default PresentMenuDownloadOptions;
